import React from 'react'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'

const FooterBottomContentBlock = ({ placeholders: { footerContents = []} = {}, ...props }) =>
  <>
    <Helmet>
      {/* This script we need to display BrightEdge Autopilot links */}
      <script src="//cdn.bc0a.com/autopilot/f00000000200128/autopilot_sdk.js" />
    </Helmet>
    <CopyrightWrapper>
      <div data-max-width>
        { footerContents }
      </div>
    </CopyrightWrapper>
    <div className="be-ix-link-block" /> {/* This block we need to display BrightEdge Autopilot links */}
  </>

FooterBottomContentBlock.propTypes = {
  '@type': PropTypes.string,
  'endeca:auditInfo': PropTypes.shape({
    'ecr:innerPath': PropTypes.string,
    'ecr:resourcePath': PropTypes.string
  }),
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    footerContents: PropTypes.arrayOf(PropTypes.shape())
  })
}

FooterBottomContentBlock.type = 'FooterBottomContentBlock'
FooterBottomContentBlock.placeholders = ['footerContents']

export default FooterBottomContentBlock

const CopyrightWrapper = styled.div`
  background-color: ${Theme.colors.black_new};
  background-size: cover;
  ${Media.mobile`
    padding: 25px 0;
    text-align: center;
  `}
  ${Media.desktop`
    padding: 16px 50px;
    border-top: 1px solid ${Theme.colors.dark_grey};
  `}
`
